// TODO_FALCON: DELETE

/**
 * Exports UI views available in RSP.
 */

export const JV_SELECTION = 'Jurisdiction';
export const QV_SELECTION = 'Query';
